import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { KonstantionAuthHttps } from '../../fetchUrls';
import { InputDinamycPlaceholder, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { ModalErr } from '../Modal/ModalErr/ModalErr';
import { TitlePage } from '../TitlePage/TitlePage';
import './ResetPasswordBox.scss';
import { processTokenResponse } from '../../common/authHelper';

const ResetPasswordBox = ({ email }) => {
  const navigate = useNavigate();
  const path = useParams();
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [inValid, setInvalid] = useState(false);
  const [isModalErr, setIsModalErr] = useState(false);
  const [err, setErr] = useState(false);

  const [errPassword, setErrPassword] = useState(false);
  const [errPasswordRepeat, setErrPasswordRepeat] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  // Эффект для сброса состояния disabled через минуту
  useEffect(() => {
    let timer;
    if (isDisabled) {
      timer = setTimeout(() => {
        setIsDisabled(false);
      }, 60000); // 60000 мс = 1 минута
    }

    // Очистка таймера при размонтировании компонента
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isDisabled]);

  const deleteErrNotofication = () => {
    setErrPassword(false);
    setErrPasswordRepeat(false);
    setErr(false);
    setInvalid(false);
  };

  const handlerSetPassword = (e) => {
    setPassword(e);
    deleteErrNotofication();
  };

  const handlerSetRepeatPassword = (e) => {
    setPasswordRepeat(e);
    deleteErrNotofication();
  };

  let form = {
    token: path['*'].split('/')[1],
    password: password,
    device_info: '',
  };

  const handlerSubmit = (e) => {
    if (password !== passwordRepeat) {
      setInvalid(true);
    } else {
      let url = `${KonstantionAuthHttps}/web/reset-password`;

      const headers = {
        'Content-type': 'application/json',
        'portal-id': '4',
      };

      fetch(url, {
        method: 'POST',
        body: JSON.stringify(form),
        headers,
      })
        .then((response) => response.json())
        .then(async (data) => {
          processTokenResponse(data)
          setIsDisabled(true)
        })
        .catch((err) => {
          setIsModalErr(true);
          console.error(err);
        });
    }
  };

  const checkInputField = () => {
    const regexPassword =
      /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/;

    if (!regexPassword.test(password)) {
      setErrPassword(true);
    }

    if (!regexPassword.test(passwordRepeat)) {
      setErrPasswordRepeat(true);
    }

    if (!regexPassword.test(password) || !regexPassword.test(passwordRepeat)) {
      return;
    } else {
      handlerSubmit();
    }
  };

  return (
    <>
      {isModalErr && (
        <ModalErr isModal={isModalErr} setIsModal={(e) => setIsModalErr(e)} />
      )}
      <div
        className="autorization"
        onSubmit={(e) => e.preventDefault()}
        spellCheck="false"
      >
        <TitlePage
          title='Придумайте пароль'
        />

        <InputDinamycPlaceholder
          onChange={handlerSetPassword}
          type="password"
          placeholder="Введите новый пароль"
          err={errPassword}
          textErr={'Пароль не соответствует требованиям'}
          autoComplete={false}
          passwordTooltip
          tooltipStatic="Пароль должен содержать не менее 8 символов, цифры и заглавные буквы"
          required
        />

        <InputDinamycPlaceholder
          onChange={handlerSetRepeatPassword}
          type="password"
          err={errPasswordRepeat}
          textErr={'Пароль не соответствует требованиям'}
          placeholder="Введите пароль еще раз"
          autoComplete={false}
          required
        />

        {inValid ? 
          <Link to="#" className="text text_red">
            Введеные пароли не совпадают
          </Link>
         : null}

        {err && <span className="text text_red">Не удалось сбросить пароль</span>}

        <ButtonBasic
          disabled={isDisabled}
          blue
          text={'Сохранить пароль'}
          width='100%'
          onClick={(e) => {
            e.preventDefault();
            checkInputField();
          }}
        />
      </div>
    </>
  );
};

export { ResetPasswordBox };